<template>
  <a
    v-tooltip="{
      content: tooltip,
      classes: 'badge-theme',
    }"
    :class="badgeClass"
  >
    <font-awesome-icon :icon="icon" />
    {{ type }}
  </a>
</template>

<script type="text/babel">
export default {
  props: {
    tooltip: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: "Messaged",
    },

    size: {
      type: String,
      required: false,
      default: "badge-large",
    },
  },

  data() {
    return {
      color: "badge-warning",
      icon: ["fal", "envelope-open-text"],
    };
  },

  computed: {
    badgeClass() {
      return `badge ${this.color} ${this.size}`;
    },
  },
};
</script>
